import React, { useMemo } from 'react';
import cx from 'classnames';
import '../../../../layout/Layout/Context/index.js';
import '../../../../layout/Layout/ScrollView/index.js';
import '../../../../layout/Layout/View/index.js';
import '../../../../layout/Layout/View/components/ToolbarWrapper/index.js';
import '../../../../layout/Layout/View/components/SearchWrapper/index.js';
import '../../../../layout/Layout/View/components/HeaderCenterWrapper/index.js';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';
import { useLayoutContext } from '../../../../layout/Layout/Context/utils/useLayoutContext.js';

const SList = ({
  className,
  style,
  children
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.list, className), style }, children);
SList.displayName = "`SecurityPanel.SList";
const SRow = ({
  className,
  style,
  children
}) => /* @__PURE__ */ React.createElement("div", { className: cx(styles.row, className), style }, children);
SRow.displayName = "SecurityPanel.SRow";
const SPanel = ({
  className,
  style,
  children
}) => {
  const { contentWidth } = useLayoutContext();
  const { windowSize } = useWindowSize();
  const isNeedMobile = useMemo(
    () => contentWidth < 700 || windowSize.width <= 1024,
    [contentWidth, windowSize]
  );
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: cx(styles.box, className, {
        [styles["mobile-styles"]]: isNeedMobile
      }),
      style
    },
    children
  );
};
SPanel.displayName = "SecurityPanel.SPanel";

export { SList, SPanel, SRow };
//# sourceMappingURL=index.js.map
